import React, { useState } from 'react';
import useMsalApi from "./use-msal-api";
import FormComboBox from './form_elements/form-combobox';

const EmployeeSelect = ({setClear, setIsEmployee, setSelectedEmployeeGuid}) => {
    const [employees, setEmployees] = useState([]);
    const [callApi] = useMsalApi();
    
    const selectEmployee = (e) => {
        console.log("Employee Change", e);
        if(!e || e.selectedItem === null){
            setIsEmployee(false);
            setClear(true);
            return;
        }
        getEmployeeID(e.selectedItem.id);
    };

    const getEmployeeID = async (id) => {
        var results = await callApi(`Employee/id/${id}`, "GET");
        if(!results.error){
            setSelectedEmployeeGuid(results);
            setIsEmployee(true);
        }
    };

    const search = async (e) => {
        if(!e || e.length < 3){
            setEmployees([{id: 1, name: "Start Typing an employee's name to see results", disabled : true}]);
            return;
        }

        var results = await callApi(`lookup/employees/${e}`);
        if(!results.error)
            setEmployees(results)
    };

    
    return(
        <>
            <FormComboBox name="selectedEmployee" label="Select an employee" items={employees} onChange={selectEmployee} onInputChange={search} 
                itemToString={ (item) => item ? item["name"] : ''} />
        </>
    );
}

export default EmployeeSelect